<template>
    <div class="product">
        product
    </div>
</template>

<script>
export default {
    name: 'product-list',
    props: {
        product: Object
    }
}
</script>

<style lang="scss" scoped>
    .product {
        height: 224px;
        width: 240px;	
        background-color: rgba(0,0,0,0.4);
        margin-right: 24px;
        flex: 240px 0 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(#000, .4);
        font-size: 12px;
    }
</style>
